import RedlistApi from '../../service/redlistApi'

import {
    put,
    takeLatest,
    select,
    takeLeading,
    delay
} from 'redux-saga/effects'
import {
    showSpinner,
    hideSpinner,
    showError
} from '../actions/uiActions'
import { 
    VIEW_QA_ASSESSMENTS_PAGE_INIT,
    VIEW_QA_ASSESSMENTS_PAGE_FETCH,
    VIEW_QA_ASSESSMENTS_PAGE_SET_ASSESSMENTS,
    VIEW_QA_ASSESSMENTS_PAGE_SET_FILTER,   
    VIEW_QA_ASSESSMENTS_SET_PAGE,
    VIEW_QA_ASSESSMENTS_PREV_PAGE,
    VIEW_QA_ASSESSMENTS_NEXT_PAGE,
    setFilter,
    setPage,
    fetchAssessments    
} from './viewQAAssessmentsPageActions'
import { initEkspertEntities } from './ekspertEntitiesActions'
import { apiRequest } from '../api/apiRequest'

function* processInit(action) {
    try {
        const { filter } = yield select(state => state.viewQaAssessmentsPage)
        if (filter.approverId) {
            yield put(setFilter(filter))
            return
        }
        let {loaded,assessors} = yield select(state => state.ekspertEntities)
        if (!loaded) {
            yield put(initEkspertEntities())
        }
        let count = 0
        while (!loaded && count < 1000) {
            yield delay(20)
            count += 1
            loaded = yield select(state => state.ekspertEntities.loaded)            
        }
        assessors = yield select(state => state.ekspertEntities.assessors)
        if (!assessors || assessors.length === 0) {
            return
        }
        yield put(setFilter({ ...filter, approverId: assessors[0].id }))
    } catch (error) {
        yield put(showError(error))
    }
}

function* processSetFilter(action) {
    try {
        yield put(fetchAssessments(action.payload))
    } catch (error) {
        yield put(showError(error))
    }
}

function* processFetchAssessments(action) {
    try {
        console.log('fetching assessments')
        yield put(showSpinner())
        const data = yield apiRequest(RedlistApi, RedlistApi.loadAssessmentsForQa, [ action.payload.filter ])
        yield put({ type: VIEW_QA_ASSESSMENTS_PAGE_SET_ASSESSMENTS, payload: { assessments: data.items, pages: data.pages, count: data.count }})
        yield put(hideSpinner())
    } catch (error) {
        yield put(hideSpinner())
        yield put(showError(error))
    }
}

function* processSetNextPage(action) {
    try {
        const filter = yield select(state => state.viewQaAssessmentsPage.filter)
        yield put(setPage(filter.page + 1))
    } catch (error) {
        yield put(showError(error))
    }
}

function* processSetPrevPage(action) {
    try {
        const filter = yield select(state => state.viewQaAssessmentsPage.filter)
        yield put(setPage(filter.page - 1))
    } catch (error) {
        yield put(showError(error))
    }
}

function* processSetPage(action) {
    try {
        const { filter, pages } = yield select(state => state.viewQaAssessmentsPage)
        let page = action.payload.page
        if (page > pages) {
            page = pages
        } else if (page < 0) {
            page = 0
        }
        yield put(setFilter({ ...filter, page }))
    } catch (error) {
        yield put(showError(error))
    }
}

export default function* watcher() {
    yield takeLeading(VIEW_QA_ASSESSMENTS_PAGE_INIT, processInit)
    yield takeLatest(VIEW_QA_ASSESSMENTS_PAGE_FETCH, processFetchAssessments)
    yield takeLatest(VIEW_QA_ASSESSMENTS_PAGE_SET_FILTER, processSetFilter)
    yield takeLatest(VIEW_QA_ASSESSMENTS_SET_PAGE, processSetPage)
    yield takeLatest(VIEW_QA_ASSESSMENTS_PREV_PAGE, processSetPrevPage)
    yield takeLatest(VIEW_QA_ASSESSMENTS_NEXT_PAGE, processSetNextPage) 
}